import { Component, Inject, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { FieldComponent } from '../../field/field.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-all-pins-delete',
    templateUrl: './all-pins-delete.component.html',
    styleUrls: ['./all-pins-delete.component.css'],
    standalone: false
})
export class AllPinsDeleteComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<FieldComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { }

  ngOnInit(): void {
  }

  deleteAllPins() {
    this.dialogRef.close({"option": "delete"});
  }

  cancel(): void {
    this.dialogRef.close({"option": "cancel"});
  }

}
